// Vrais témoignages clients UNIQUEMENT (avec accord écrit). Tableau vide = section masquée.
// Format : { quote, author, role, company, rating (1-5), date: 'YYYY-MM-DD', lang: 'fr'|'en'|'de' }
const TESTIMONIALS = [];

export default TESTIMONIALS;
